var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _c("div", { staticClass: "row custom-row" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12 col-xs-12 col-md-12" }, [
              _c("hr", { staticClass: "mr-bt-4" }),
              _c(
                "div",
                { staticClass: "row ipad-row" },
                [
                  _vm._m(0),
                  _vm._l(_vm.panelInfo, function (panel) {
                    return _c(
                      "div",
                      {
                        key: panel.id,
                        staticClass: "col-md-2 col-sm-2 col-xs-6 width-auto",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-check" },
                          [
                            _c(
                              "base-radio",
                              {
                                attrs: {
                                  id: panel.id,
                                  optionValue: panel.id,
                                  label: panel.id,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.selectPanel()
                                  },
                                },
                                model: {
                                  value: _vm.panel_id,
                                  callback: function ($$v) {
                                    _vm.panel_id = $$v
                                  },
                                  expression: "panel_id",
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(panel.name))])]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c("hr", { staticClass: "mt-0" }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "box-wrapper" }, [
          _vm.panel_id !== 1
            ? _c("div", { staticClass: "row custom-row mr-tp-10" }, [
                _c("span", [
                  _vm._v("Select a RAMS feature for each panel below"),
                ]),
              ])
            : _vm._e(),
          _vm.panel_id == 1 && _vm.panelInfo
            ? _c("div", { staticClass: "col-xs-12 center" }, [
                _c("img", {
                  staticClass: "default-img",
                  attrs: {
                    src: "/static/images/marketplace/default-dashboard.png",
                    alt: "default-img",
                  },
                }),
              ])
            : _vm._e(),
          _vm.panel_id !== 1
            ? _c("div", { staticClass: "row custom-row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6 col-sm-12 col-xs-12" },
                  _vm._l(
                    _vm.panelsDisplay.card_widget_info,
                    function (panels, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "row mt-20" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-2 col-sm-12 col-xs-12 p-0",
                              class: {
                                "mr-tp-4": panels.fixed_panel_widget_id == null,
                              },
                            },
                            [
                              _vm._v(
                                " Panel " + _vm._s(panels.card_number) + ": "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-8 col-sm-12 col-xs-12 p-0" },
                            [
                              panels.fixed_panel_widget_id != null
                                ? _c(
                                    "span",
                                    { staticClass: "custom-font ml-20" },
                                    [
                                      _vm._v(
                                        _vm._s(panels.list[0].drop_down_name)
                                      ),
                                      _c("span", { staticClass: "fw-300" }, [
                                        _vm._v(" (fixed)"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.selectedPanel[index].panel_widget_id != 1 &&
                              !_vm.panelCardIdList.includes(
                                _vm.selectedPanel[index].panel_card_id
                              )
                                ? _c(
                                    "multiselect",
                                    {
                                      staticClass:
                                        "multiselect-single-dropdown",
                                      class: !_vm.selectedPanel[index]
                                        .panel_widget_id
                                        ? "un-selected"
                                        : "",
                                      attrs: {
                                        showLabels: false,
                                        "close-on-select": true,
                                        "allow-empty": false,
                                        searchable: false,
                                        options: panels.list.map(
                                          (dropdownObj) => dropdownObj.id
                                        ),
                                        "custom-label": (option) =>
                                          panels.list.find(
                                            (x) => x.id === option
                                          ).drop_down_name,
                                        placeholder: "Select",
                                      },
                                      model: {
                                        value:
                                          _vm.selectedPanel[index]
                                            .panel_widget_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selectedPanel[index],
                                            "panel_widget_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "selectedPanel[index].panel_widget_id",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "noResult" },
                                          slot: "noResult",
                                        },
                                        [_vm._v("No matching data")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.selectedPanel[index].panel_widget_id != 1 &&
                              _vm.panelCardIdList.includes(
                                _vm.selectedPanel[index].panel_card_id
                              )
                                ? _c("multiselect", {
                                    staticClass: "multiselect-single-dropdown",
                                    class: !_vm.selectedPanel[index]
                                      .panel_widget_id
                                      ? "un-selected"
                                      : "",
                                    attrs: {
                                      showLabels: false,
                                      "close-on-select": true,
                                      "allow-empty": false,
                                      searchable: false,
                                      "open-direction": "bottom",
                                      options: panels.list.map(
                                        (dropdownObj) => dropdownObj.id
                                      ),
                                      "custom-label": (option) =>
                                        panels.list.find((x) => x.id === option)
                                          .drop_down_name,
                                      placeholder: "Select",
                                    },
                                    model: {
                                      value:
                                        _vm.selectedPanel[index]
                                          .panel_widget_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedPanel[index],
                                          "panel_widget_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedPanel[index].panel_widget_id",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "col-md-5 col-sm-12 col-xs-12 panel-box" },
                  [
                    _c("div", { staticClass: "box1" }, [
                      _vm._m(1),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "panel-other",
                            class: {
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12":
                                _vm.panel_id == 2,
                              "col-lg-6 col-md-6 col-sm-6 col-xs-6":
                                _vm.panel_id == 3,
                              "col-lg-4 col-md-4 col-sm-4 col-xs-4":
                                _vm.panel_id == 4,
                            },
                          },
                          [_vm._v(" 4 ")]
                        ),
                        _vm.panel_id != 2
                          ? _c(
                              "div",
                              {
                                staticClass: "panel-other",
                                class: {
                                  "col-lg-6 col-md-6 col-sm-6 col-xs-6":
                                    _vm.panel_id == 3,
                                  "col-lg-4 col-md-4 col-sm-4 col-xs-4":
                                    _vm.panel_id == 4,
                                },
                              },
                              [_vm._v(" 5 ")]
                            )
                          : _vm._e(),
                        _vm.panel_id == 4
                          ? _c(
                              "div",
                              {
                                staticClass: "panel-other",
                                class: {
                                  "col-lg-4 col-md-4 col-sm-4 col-xs-4":
                                    _vm.panel_id == 4,
                                },
                              },
                              [_vm._v(" 6 ")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-12 footer" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-2 col-sm-3 col-xs-5 col-md-offset-7 col-sm-offset-5",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-block emergo-white-button",
                    attrs: { type: "button" },
                    on: { click: _vm.cancelPreferences },
                  },
                  [_vm._v(" Cancel ")]
                ),
              ]
            ),
            _c("div", { staticClass: "col-md-3 col-xs-7 col-sm-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-block emergo-green-button",
                  attrs: { type: "button" },
                  on: { click: _vm.savePreferences },
                },
                [_vm._v(" Save Changes ")]
              ),
            ]),
          ]),
        ]),
      ],
      _c("error-modal", { attrs: { errorMessage: _vm.errorMessage } }),
      _c("success-modal", {
        attrs: { successMessage: _vm.successMessage },
        on: {
          closeParent: function ($event) {
            return _vm.closePopup(true)
          },
        },
      }),
      _c("confirm-modal", {
        attrs: { confirmMessage: _vm.confirmMessage },
        on: { closePopup: _vm.closePopup },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-2 col-sm-3 col-xs-12 portrait-xs-12-width" },
      [_c("span", [_vm._v("Panel Selector:")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8 panel-1" },
        [_vm._v("1")]
      ),
      _c("div", { staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4" }, [
        _c("div", { staticClass: "row panel-other" }, [_vm._v("2")]),
        _c("div", { staticClass: "row panel-other" }, [_vm._v("3")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }